/* ===========================================================================
   Gold Spell — LP da loja internacional oficial dentro da MKPBR
   Versao 2 (18/09/2026). Vitrine, ficha do produto, carrinho proprio,
   busca, seletores e faixa de mercado. Molde: Prohall v2 + Super Cacheada.

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #gs-cfg.

   O QUE MUDOU EM RELACAO A VERSAO 1, e por que:
   - Familias por PALAVRA DO HANDLE, nao por lista fixa de handles. A lista
     da versao 1 envelheceu: a MKPBR recadastrou o catalogo com handles novos
     e 53 dos 81 produtos cairam na prateleira "mascaras" por falta de mapa,
     enquanto "pre-poo" ficava com zero produtos e "a partir de $∞".
     Handle nao e traduzido (titulo e), entao a regra vale nos 11 idiomas.
   - Produto com variante (tamanho) nao vai direto ao carrinho: abre a ficha
     para a pessoa escolher. A versao 1 mandava sempre a primeira variante.
   - Descricao completa e resumo por IA descem SO quando a ficha abre
     (?view=gold-spell-info), com cache. Antes iam todos no HTML (1,6 MB).
   - Paginas 2..N pelo ?view=gold-spell-data, que devolve SO o JSON.
   - Carrinho proprio, barra de frete, Entrega Garantida em varios pontos.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[gold-spell] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('gs-cfg', {});
  var RAW = readJSON('gs-data', []);

  /* O Liquid devolve numero como texto em varios campos (a nota chega como
     "4.9"). Converte UMA vez, logo depois de ler o JSON. */
  function normVar(v) {
    v.pr = Number(v.pr) || 0;
    v.prf = String(v.prf == null ? '' : v.prf);
    v.cmpf = v.cmpf ? String(v.cmpf) : null;
    v.av = v.av === true || v.av === 'true';
    v.t = String(v.t == null ? '' : v.t);
    return v;
  }
  function prepara(lista) {
    return (lista || []).filter(function (p) { return p && p.h && p.v && p.v.length; }).map(function (p) {
      p.v = p.v.map(normVar);
      p.img = Array.isArray(p.img) ? p.img.filter(function (i) { return i && i.s; }) : [];
      p.tags = Array.isArray(p.tags) ? p.tags : [];
      p.rr = p.rr == null ? null : parseFloat(p.rr);
      if (!isFinite(p.rr)) p.rr = null;
      p.rc = Math.round(parseFloat(p.rc) || 0);
      p.av = p.v.some(function (v) { return v.av; });
      var disp = p.v.filter(function (v) { return v.av; });
      var base = (disp.length ? disp : p.v).slice().sort(function (a, b) { return a.pr - b.pr; });
      p.min = base[0];
      /* "a partir de" so quando os precos REALMENTE diferem */
      p.faixa = p.v.length > 1 && p.v.some(function (v) { return v.pr !== p.v[0].pr; });
      p.multi = p.v.length > 1;
      p.fam = familia(p);
      p.goals = objetivos(p);
      p.isKit = p.fam === 'kits';
      return p;
    });
  }

  /* ---------- idiomas ----------------------------------------------------
     O texto FIXO da pagina ja sai pronto do servidor (snippets/gold-spell-i18n).
     Aqui chegam so as chaves que este arquivo usa para desenhar card, ficha,
     carrinho e busca — ja no idioma do mercado, num JSON dentro da pagina. */
  var ISO = CFG.iso || D.documentElement.lang || 'en';
  var PACK = readJSON('gs-i18n', {});
  function t(k) { return PACK[k] || ''; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtNum(n) {
    try { return new Intl.NumberFormat(ISO + '-u-nu-latn').format(n); } catch (e) { return String(n); }
  }

  /* ---------- dinheiro --------------------------------------------------- */
  var CURRENCY = 'USD';
  /* Usado SO no carrinho: o /cart.js entrega a moeda do mercado. Nos cards e
     na ficha usamos v.prf, que o Liquid ja formatou. */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n); }
    catch (e) { return CURRENCY + ' ' + n.toFixed(2); }
  }
  /* prf/cmpf chegam prontos ("€46,95", "Dhs. 141.00"). Para calcular a
     economia preciso do numero, e para mostra-la, do mesmo formato. */
  function parseMoney(s) {
    var n = String(s == null ? '' : s).replace(/[^\d.,]/g, '');
    if (!n) return NaN;
    var dec = /[.,](\d{1,2})$/.exec(n);
    if (dec) return parseFloat(n.slice(0, n.length - dec[0].length).replace(/[.,]/g, '') + '.' + dec[1]);
    return parseFloat(n.replace(/[.,]/g, ''));
  }
  function moneyLike(modelo, valor) {
    var m = String(modelo);
    var achou = /[\d][\d.,\s]*/.exec(m);
    if (!achou) return null;
    var semDecimal = !/[.,]\d{1,2}\s*$/.test(achou[0]);
    var virgula = /,\d{1,2}\s*$/.test(achou[0]);
    var txt = semDecimal ? String(Math.round(valor)) : valor.toFixed(2);
    if (virgula) txt = txt.replace('.', ',');
    return m.replace(achou[0].replace(/\s+$/, ''), txt);
  }

  /* ---------- familias (categorias do site oficial) ------------------------
     Por PALAVRA DO HANDLE + tag. A ordem dos testes importa:
       corpo > linha Poderosa > shampoo+condicionador > kits > mascaras >
       finalizadores > shampoo avulso > tratamentos.
     - "Shampoo e Condicionador X" a marca vende como UM produto, na categoria
       Shampoo e condicionador — por isso o duo vem ANTES de kits.
     - Linha Poderosa: e categoria no site oficial. "Laranja Poderoso" e outra
       linha (fica em mascaras/shampoo/tratamento), e kit continua em kits. */
  var FAMILIAS = ['powerful', 'treat', 'masks', 'wash', 'finish', 'kits', 'body'];
  function tagSet(p) { return p.tags.map(function (x) { return String(x).toLowerCase(); }); }
  function familia(p) {
    var h = String(p.h).toLowerCase();
    var tg = tagSet(p);
    var tem = function (t) { return tg.indexOf(t) > -1; };
    if (tem('bath & body') || tem('body care') || /body|soneca-goold|demanga/.test(h)) return 'body';
    if (/powerful|poderos/.test(h) && !/laranja|orange/.test(h) && !/kit|bundle|piece|serum-set|-set-|5-in-1/.test(h)) return 'powerful';
    if (/shampoo/.test(h) && /conditioner|condy/.test(h)) return 'wash';
    if (/kit|bundle|ritual|-set$|-set-|-duo|piece|5-in-1|schedule|cronoterapia|growth-set/.test(h)) return 'kits';
    if (tem('hair mask') || /mask|mascara|caseirinho/.test(h)) return 'masks';
    if (tem('hair oil / serum') || tem('hair cream / leave-in') || tem('hair styling cream / gel /mousse') ||
        /serum|oil|finisher|leave-in|repairer|mousse|jelly|sap|spray|unmake|obrigatoria/.test(h)) return 'finish';
    if (/shampoo|condy|conditioner|shampeeling/.test(h) || tem('shampoo & conditioner')) return 'wash';
    return 'treat';
  }

  /* Objetivo do cabelo (abas). Um produto pode ter mais de um objetivo. */
  var OBJETIVOS = ['growth', 'smooth', 'repair', 'hydrate', 'curls'];
  function objetivos(p) {
    var h = String(p.h).toLowerCase();
    var tg = tagSet(p);
    var out = [];
    if (tg.indexOf('hair growth') > -1 || /tonic|tonico|everkapsula|shampeeling|growth/.test(h)) out.push('growth');
    if (tg.indexOf('hair straightening product') > -1 || /alisei|liso-etico|smooth|fioterapia|o-shampoo/.test(h)) out.push('smooth');
    if (/dnaplex|acidgold|milagrosa|pos-quimica|repair(?!er)|reconstr|split/.test(h)) out.push('repair');
    if (/sleep-effect|soneca|morangold|girassow|calmomila|aloe|babosa|caseirinho|hydrat|laranja|schedule|receitinha|cronoterapia/.test(h)) out.push('hydrate');
    if (/cachonut|curl/.test(h)) out.push('curls');
    return out;
  }

  /* Ordem dentro da prateleira: disponivel antes de esgotado; depois a linha
     da marca junta; depois o passo da rotina; o kit fecha. */
  var PESO = [['pre-poo', 5], ['shampoo', 10], ['condy', 20], ['conditioner', 20], ['mask', 30], ['mascara', 30],
    ['treatment', 35], ['tonic', 40], ['tonico', 40], ['serum', 50], ['leave-in', 55], ['finisher', 56], ['spray', 58],
    ['oil', 60], ['jelly', 62], ['mousse', 64], ['cream', 66], ['kit', 90]];
  function peso(p) {
    var s = String(p.h).toLowerCase();
    for (var i = 0; i < PESO.length; i++) { if (s.indexOf(PESO[i][0]) > -1) return PESO[i][1]; }
    return 70;
  }
  var LINHAS = ['powerful', 'poderos', 'laranja', 'alisei', 'liso-etico', 'dnaplex', 'acidgold', 'sleep-effect', 'soneca',
    'morangold', 'girassow', 'calmomila', 'aloe', 'babosa', 'cachonut', 'caseirinho', 'everk', 'receitinha', 'milagrosa'];
  function linha(p) {
    var s = String(p.h).toLowerCase();
    for (var i = 0; i < LINHAS.length; i++) { if (s.indexOf(LINHAS[i]) > -1) return i; }
    return 99;
  }
  function ordena(a, b) {
    if (a.av !== b.av) return a.av ? -1 : 1;
    var la = linha(a), lb = linha(b);
    if (la !== lb) return la - lb;
    var pa = peso(a), pb = peso(b);
    if (pa !== pb) return pa - pb;
    return a.min.pr - b.min.pr;
  }
  /* nas abas: produto avulso antes de kit (quem escolhe por objetivo quer
     ver o produto, e o kit aparece depois) */
  function ordenaAba(a, b) {
    if (a.av !== b.av) return a.av ? -1 : 1;
    if (a.isKit !== b.isKit) return a.isKit ? 1 : -1;
    return ordena(a, b);
  }

  var PRODUCTS = prepara(RAW);

  /* ---------- imagens com srcset -----------------------------------------
     O Liquid entrega a URL com &width=600; aqui ela vira um srcset com 300,
     450 e 600 px — o celular baixa a menor que serve. */
  function imgW(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(src) { return [300, 450, 600].map(function (w) { return imgW(src, w) + ' ' + w + 'w'; }).join(', '); }

  /* ---------- selo da Entrega Garantida ------------------------------------
     Abaixo de ~20px a arte oficial (que tem texto) vira borrao: no micro-selo
     do card entra o escudo em SVG. */
  var ESCUDO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SELO = CFG.seloUrl ? '<img class="gs-selo-img" src="' + esc(CFG.seloUrl) + '" alt="" width="120" height="126" loading="lazy">' : ESCUDO;

  /* ---------- vitrine ---------------------------------------------------- */
  function precoHTML(p) {
    var v = p.min;
    var corpo = v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' + esc(v.prf) : esc(v.prf);
    return p.faixa ? '<span class="gs-card__from">' + esc(t('from')) + '</span>' + corpo : corpo;
  }
  function desconto(p) {
    var v = p.min;
    if (!v.cmpf) return null;
    var de = parseMoney(v.cmpf), por = parseMoney(v.prf);
    if (!isFinite(de) || !isFinite(por) || de <= por) return null;
    return { pct: Math.round((1 - por / de) * 100), economia: de - por };
  }
  function offHTML(p) {
    var d = desconto(p);
    return (!d || d.pct < 5) ? '' : '<span class="gs-card__off">-' + d.pct + '% ' + esc(t('off')) + '</span>';
  }
  function saveHTML(p) {
    var d = desconto(p);
    if (!d || d.economia < 1) return '';
    var txt = moneyLike(p.min.prf, d.economia);
    return txt ? '<span class="gs-card__save">' + esc(t('save').replace('{v}', txt)) + '</span>' : '';
  }
  /* Estrelas SO quando o produto tem nota cadastrada (metafield de reviews).
     Nada de nota inventada nem de distribuicao inventada — a versao 1
     desenhava uma barra de 86% "5 estrelas" que nao vinha de dado nenhum. */
  function starsHTML(p) {
    if (!p.rr || !p.rc) return '';
    var cheias = Math.round(p.rr);
    return '<div class="gs-stars" aria-label="' + esc(p.rr.toFixed(1) + ' / 5') + '"><i aria-hidden="true">' +
      '★★★★★'.slice(0, cheias) + '☆☆☆☆☆'.slice(0, 5 - cheias) + '</i>' +
      esc(p.rr.toFixed(1)) + ' (' + fmtNum(p.rc) + ')</div>';
  }

  function cardHTML(p) {
    var img = p.img[0] || {};
    var rotulo = !p.av ? t('soldout') : (p.multi ? t('pdp_choose_card') : t('add'));
    var attr = p.multi ? ' data-gs-open-handle="' + esc(p.h) + '"' : ' data-gs-add="' + p.min.id + '"';
    return '' +
      '<div class="gs-card__img">' +
        (img.s ? '<img src="' + esc(imgW(img.s, 450)) + '" srcset="' + esc(srcset(img.s)) + '" sizes="(max-width:700px) 46vw, 232px"' +
          ' alt="' + esc(img.a || p.t) + '" loading="lazy" decoding="async" width="600" height="600">' : '') +
        offHTML(p) +
        '<span class="gs-card__quick" aria-hidden="true">' + esc(t('quick')) + '</span>' +
        (p.av ? '' : '<span class="gs-card__flag">' + esc(t('soldout')) + '</span>') +
      '</div>' +
      '<div class="gs-card__body">' +
        '<h3>' + esc(p.t) + '</h3>' +
        starsHTML(p) +
        '<div class="gs-card__price">' + precoHTML(p) + '</div>' +
        saveHTML(p) +
        /* micro-selo da Entrega Garantida: responde antes do clique */
        '<span class="gs-card__del">' + ESCUDO + esc(t('del_card')) + '</span>' +
        '<button type="button" class="gs-btn gs-btn--sm gs-btn--full gs-card__add"' + attr + (p.av ? '' : ' disabled') + '>' + esc(rotulo) + '</button>' +
      '</div>';
  }
  /* O card NAO pode ser um <button> (botao dentro de botao e HTML invalido):
     div com role=button, e o clique no botao de comprar e tratado ANTES. */
  function cardEl(p) {
    var el = D.createElement('div');
    el.className = 'gs-card' + (p.av ? '' : ' gs-card--out');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', p.t);
    el.dataset.gsHandle = p.h;
    el.innerHTML = cardHTML(p);
    return el;
  }

  function porHandle(h) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].h === h) return PRODUCTS[i];
    return null;
  }

  function renderGrids() {
    var vazio = !PRODUCTS.length;
    var painel = $('[data-gs-nostock]');
    if (painel) painel.hidden = !vazio;
    if (vazio) {
      $$('.gs-shelf').forEach(function (s) { s.hidden = true; });
      ['#gs-cats', '#gs-goals', '.gs-fams', '.gs-parade', '.gs-parade__cap'].forEach(function (s) { var e = $(s); if (e) e.hidden = true; });
      return;
    }

    var buckets = {};
    FAMILIAS.forEach(function (k) { buckets[k] = []; });
    PRODUCTS.forEach(function (p) { if (buckets[p.fam]) buckets[p.fam].push(p); });

    FAMILIAS.forEach(function (k) {
      var grid = $('[data-gs-grid="' + k + '"]');
      var list = buckets[k].sort(ordena);
      var sec = grid ? grid.closest('.gs-shelf') : null;
      /* Familia vazia: some a prateleira E todo atalho que aponta para ela
         (um chip que rola para uma secao escondida nao leva a lugar nenhum).
         Foi o "Pre-Poo 0 produtos · a partir de $∞" da versao 1. */
      var atalhos = $$('a[href="#gs-fam-' + k + '"]');
      if (!list.length) {
        if (sec) sec.hidden = true;
        atalhos.forEach(function (a) { (a.closest('li') || a).hidden = true; });
        return;
      }
      if (sec) sec.hidden = false;
      atalhos.forEach(function (a) { (a.closest('li') || a).hidden = false; });
      if (grid) {
        grid.innerHTML = '';
        grid.setAttribute('aria-busy', 'false');
        list.forEach(function (p) { grid.appendChild(cardEl(p)); });
      }
      $$('[data-gs-count-fam="' + k + '"]').forEach(function (n) { n.textContent = fmtNum(list.length); });
      pintaCartaoFamilia(k, list);
      ligaRail(railDe(k));
    });

    pintaAbas();
    montaParada();
    montaPopulares();
  }

  /* Cartao de familia do topo: foto do primeiro produto avulso disponivel,
     e "N produtos · a partir de X" com o menor preco da familia. */
  function pintaCartaoFamilia(k, list) {
    var card = $('[data-gs-famcard="' + k + '"]');
    if (!card) return;
    var capa = list.filter(function (p) { return p.av && !p.isKit && p.img[0]; })[0] || list.filter(function (p) { return p.img[0]; })[0];
    var img = $('[data-gs-famimg]', card);
    if (img && capa && img.dataset.h !== capa.h) {
      img.dataset.h = capa.h;
      img.src = imgW(capa.img[0].s, 200);
    }
    var disp = list.filter(function (p) { return p.av; });
    var menor = (disp.length ? disp : list).slice().sort(function (a, b) { return a.min.pr - b.min.pr; })[0];
    var from = $('[data-gs-famfrom]', card);
    if (from) from.textContent = fmtNum(list.length) + ' · ' + t('from') + ' ' + menor.min.prf;
  }

  /* ---------- faixa de produtos do hero ----------------------------------- */
  function montaParada() {
    var track = $('[data-gs-parade]');
    if (!track) return;
    var lista = (CFG.parade || []).map(porHandle).filter(function (p) { return p && p.av && p.img[0]; });
    if (lista.length < 6) {
      PRODUCTS.forEach(function (p) { if (lista.length < 12 && p.av && !p.isKit && p.img[0] && lista.indexOf(p) < 0) lista.push(p); });
    }
    var chave = lista.map(function (p) { return p.h; }).join(',');
    if (track.dataset.chave === chave) return;
    track.dataset.chave = chave;
    /* duas copias para o loop continuo; a segunda e aria-hidden */
    var um = lista.map(function (p) {
      return '<img src="' + esc(imgW(p.img[0].s, 240)) + '" alt="" width="240" height="240" decoding="async" fetchpriority="low">';
    }).join('');
    var dois = lista.map(function (p) {
      return '<img src="' + esc(imgW(p.img[0].s, 240)) + '" alt="" width="240" height="240" decoding="async" loading="lazy" aria-hidden="true">';
    }).join('');
    track.innerHTML = um + dois;
  }

  /* ==========================================================================
     CARROSSEL DE UMA LINHA — scroll NATIVO; as setas so empurram o scroll.
     ========================================================================== */
  function railDe(k) { return $('[data-gs-rail="' + k + '"]'); }
  function atualizaSetas(rail) {
    if (!rail) return;
    var track = $('.gs-rail__track', rail);
    var prev = $('[data-gs-rail-prev]', rail);
    var next = $('[data-gs-rail-next]', rail);
    if (!track || !prev || !next) return;
    if (rail.classList.contains('gs-rail--grid')) { prev.hidden = true; next.hidden = true; return; }
    var max = track.scrollWidth - track.clientWidth;
    var x = Math.abs(track.scrollLeft); /* em RTL o Chrome devolve scrollLeft negativo */
    var sobra = max > 4;
    prev.hidden = !sobra || x < 8;
    next.hidden = !sobra || x > max - 8;
  }
  function ligaRail(rail) {
    if (!rail) return;
    var track = $('.gs-rail__track', rail);
    if (!track) return;
    if (!rail.dataset.pronto) {
      rail.dataset.pronto = '1';
      track.addEventListener('scroll', function () { atualizaSetas(rail); }, { passive: true });
      /* a largura do conteudo muda quando as fotos chegam: refaz a conta */
      track.addEventListener('load', function () { atualizaSetas(rail); }, true);
      $$('[data-gs-rail-prev],[data-gs-rail-next]', rail).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var dir = b.hasAttribute('data-gs-rail-next') ? 1 : -1;
          if (D.documentElement.dir === 'rtl') dir = -dir;
          track.scrollBy({ left: dir * Math.max(240, track.clientWidth * 0.8), behavior: 'smooth' });
        });
      });
    }
    atualizaSetas(rail);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { atualizaSetas(rail); });
    setTimeout(function () { atualizaSetas(rail); }, 500);
  }
  function ligaVerTodos() {
    $$('[data-gs-toggle]').forEach(function (b) {
      if (b.dataset.pronto) return;
      b.dataset.pronto = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var rail = railDe(b.dataset.gsToggle);
        if (!rail) return;
        var grade = rail.classList.toggle('gs-rail--grid');
        var rot = $('span', b);
        if (rot) rot.textContent = grade ? t('see_less') : t('see_all');
        b.setAttribute('aria-expanded', String(grade));
        atualizaSetas(rail);
      });
    });
  }

  /* Barra de familias FIXA: acende quando os cartoes de familia saem por cima
     da tela, apaga quando o rodape aparece. Medida direta a cada rolagem (o
     IntersectionObserver perde saltos de ancora — medido na Prohall). */
  function ligaBarraFamilias() {
    var barra = $('[data-gs-fams]');
    var ref = $('#gs-cats');
    if (!barra || !ref || !PRODUCTS.length || barra.dataset.pronto) return;
    barra.dataset.pronto = '1';
    var rodape = $('.gs-foot');
    var chips = $$('.gs-fam', barra);
    var pedido = false;
    function mede() {
      pedido = false;
      var passou = ref.getBoundingClientRect().bottom < 70;
      var fim = rodape ? rodape.getBoundingClientRect().top < window.innerHeight : false;
      barra.classList.toggle('is-on', passou && !fim);
      /* acende o chip da prateleira que esta na tela */
      var atual = null;
      FAMILIAS.forEach(function (k) {
        var s = D.getElementById('gs-fam-' + k);
        if (s && !s.hidden && s.getBoundingClientRect().top < 180) atual = k;
      });
      chips.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('href') === '#gs-fam-' + atual); });
    }
    function agenda() {
      if (pedido) return;
      pedido = true;
      if (window.requestAnimationFrame) requestAnimationFrame(mede); else setTimeout(mede, 60);
    }
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    mede();
  }

  /* ---------- abas por objetivo ------------------------------------------- */
  var TAB = 'growth';
  var TAB_D = { growth: 's1', smooth: 's2', repair: 's3', hydrate: 'goal_hyd_d', curls: 'goal_curls_d' };
  function pintaAbas() {
    var grid = $('[data-gs-grid="tabs"]');
    if (!grid) return;
    /* aba sem produto no mercado atual some */
    $$('[data-gs-tab]').forEach(function (b) {
      var k = b.dataset.gsTab;
      b.hidden = !PRODUCTS.some(function (p) { return p.goals.indexOf(k) > -1; });
    });
    var atual = $('[data-gs-tab="' + TAB + '"]');
    if (atual && atual.hidden) {
      var primeira = $$('[data-gs-tab]').filter(function (b) { return !b.hidden; })[0];
      if (primeira) selecionaAba(primeira, true);
      return;
    }
    var lista = PRODUCTS.filter(function (p) { return p.goals.indexOf(TAB) > -1; }).sort(ordenaAba).slice(0, 12);
    grid.innerHTML = '';
    lista.forEach(function (p) { grid.appendChild(cardEl(p)); });
    var d = $('[data-gs-tab-desc]');
    if (d) d.textContent = t(TAB_D[TAB] || '');
    var rail = railDe('tabs');
    if (rail) { var tr = $('.gs-rail__track', rail); if (tr) tr.scrollLeft = 0; ligaRail(rail); }
  }
  function selecionaAba(b, semFoco) {
    TAB = b.dataset.gsTab;
    $$('[data-gs-tab]').forEach(function (x) {
      var on = x === b;
      x.classList.toggle('is-on', on);
      x.setAttribute('aria-selected', String(on));
      x.tabIndex = on ? 0 : -1;
    });
    pintaAbas();
    if (!semFoco) b.focus();
  }
  function ligaAbas() {
    var abas = $$('[data-gs-tab]');
    abas.forEach(function (b) {
      b.tabIndex = b.classList.contains('is-on') ? 0 : -1;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); selecionaAba(b); });
      /* setas do teclado entre abas (padrao de tablist) */
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var vis = abas.filter(function (x) { return !x.hidden; });
        var i = vis.indexOf(b);
        var passo = (e.key === 'ArrowRight' ? 1 : -1) * (D.documentElement.dir === 'rtl' ? -1 : 1);
        var alvo = vis[(i + passo + vis.length) % vis.length];
        if (alvo) { e.preventDefault(); selecionaAba(alvo); }
      });
    });
  }

  /* ==========================================================================
     BUSCA — inteira no navegador, sobre o JSON ja baixado (nada de /search,
     que traria outras marcas para dentro da loja da Gold Spell).
     ========================================================================== */
  var buscaEl, buscaVeil, buscaInput, buscaRes, buscaSug, buscaNone, buscaT;
  function normal(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* motor antigo */ }
    return s;
  }
  function buscar(q) {
    var n = normal(q).trim();
    if (n.length < 2) return [];
    var termos = n.split(/\s+/);
    return PRODUCTS.filter(function (p) {
      /* o handle entra na busca: e em ingles e nao muda com o idioma, entao
         "sleep effect" acha o produto mesmo com o titulo traduzido */
      var alvo = normal(p.t) + ' ' + normal(p.h.replace(/-/g, ' ')) + ' ' + normal(p.tags.join(' ')) + ' ' +
                 normal(p.v.map(function (v) { return v.sku || ''; }).join(' '));
      return termos.every(function (x) { return alvo.indexOf(x) > -1; });
    }).sort(ordenaAba).slice(0, 40);
  }
  function sresHTML(p) {
    var img = (p.img[0] || {}).s || '';
    return '<button type="button" class="gs-sres" data-gs-open-handle="' + esc(p.h) + '">' +
      '<span class="gs-sres__img">' + (img ? '<img src="' + esc(imgW(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span><b>' + esc(p.t) + '</b><span>' + precoHTML(p) + '</span></span></button>';
  }
  /* "Maiores descontos" so quando existe desconto de verdade no mercado;
     sem isso, "por onde comecar" com os produtos-vitrine da marca. */
  function montaPopulares() {
    var alvo = $('[data-gs-search-popular]');
    if (!alvo) return;
    var titulo = $('[data-gs-search-popular-t]');
    var lista = PRODUCTS.filter(function (p) { return p.av && !p.isKit && desconto(p); })
      .sort(function (a, b) { return desconto(b).pct - desconto(a).pct; }).slice(0, 4);
    var chave = 'search_popular';
    if (lista.length < 4) {
      chave = 'search_start';
      lista = (CFG.parade || []).map(porHandle).filter(function (p) { return p && p.av; }).slice(0, 4);
    }
    if (titulo) titulo.textContent = t(chave);
    alvo.innerHTML = lista.map(sresHTML).join('');
  }
  function pintaResultados(q) {
    if (!buscaRes) return;
    var lista = buscar(q);
    var temTermo = normal(q).trim().length >= 2;
    if (buscaSug) buscaSug.hidden = temTermo;
    buscaRes.hidden = !temTermo;
    if (buscaNone) buscaNone.hidden = !(temTermo && !lista.length);
    buscaRes.innerHTML = lista.map(sresHTML).join('');
  }
  function abrirBusca(termo) {
    if (!buscaEl) return;
    if (termo != null && buscaInput) { buscaInput.value = termo; pintaResultados(termo); }
    if (buscaEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    buscaEl.classList.add('is-on');
    buscaEl.setAttribute('aria-hidden', 'false');
    if (buscaVeil) { buscaVeil.hidden = false; requestAnimationFrame(function () { buscaVeil.classList.add('is-on'); }); }
    travarRolagem();
    if (buscaInput) setTimeout(function () { buscaInput.focus(); }, 60);
  }
  function fecharBusca() {
    if (!buscaEl || !buscaEl.classList.contains('is-on')) return;
    buscaEl.classList.remove('is-on');
    buscaEl.setAttribute('aria-hidden', 'true');
    if (buscaVeil) { buscaVeil.classList.remove('is-on'); setTimeout(function () { buscaVeil.hidden = true; }, 220); }
    destravarRolagem();
  }
  function ligaBusca() {
    buscaEl = $('[data-gs-search]');
    buscaVeil = $('[data-gs-search-veil]');
    buscaInput = $('[data-gs-search-input]');
    buscaRes = $('[data-gs-search-results]');
    buscaSug = $('[data-gs-search-suggest]');
    buscaNone = $('[data-gs-search-none]');
    if (!buscaEl || !buscaInput) return;
    buscaInput.addEventListener('input', function () {
      clearTimeout(buscaT);
      var v = buscaInput.value;
      buscaT = setTimeout(function () { pintaResultados(v); }, 120);
    });
    buscaInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(buscaT); pintaResultados(buscaInput.value); }
    });
  }

  /* ---------- paginas 2..N --------------------------------------------------
     Pelo ?view=gold-spell-data, que devolve SO o JSON (layout none). Tres
     tentativas com pausa crescente: um 502 do proprio Shopify ja tirou metade
     da vitrine da Prohall sem aviso nenhum. */
  function buscaPagina(n, tentativa) {
    var url = (CFG.root || '') + '/pages/gold-spell?view=gold-spell-data&page=' + n;
    /* SEM "Accept: application/json": com esse cabecalho a Shopify ignora o
       ?view= e devolve a representacao JSON nativa da pagina (medido no
       preview em 18/09/2026 — a pagina 2 voltava vazia). */
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        var j = JSON.parse(txt);
        if (!j || !j.products || !j.products.length) throw new Error('pagina vazia');
        return j.products;
      })
      .catch(function (err) {
        if (tentativa >= 3) { console.warn('[gold-spell] pagina ' + n + ' nao veio:', err.message); return []; }
        return new Promise(function (ok) { setTimeout(ok, 400 * tentativa); }).then(function () { return buscaPagina(n, tentativa + 1); });
      });
  }
  function carregarResto() {
    var total = Number(CFG.pages) || 1;
    if (total < 2 || !PRODUCTS.length) return Promise.resolve();
    var pedidos = [];
    for (var n = 2; n <= total; n++) pedidos.push(buscaPagina(n, 1));
    return Promise.all(pedidos).then(function (partes) {
      var vistos = {};
      PRODUCTS.forEach(function (p) { vistos[p.h] = true; });
      var novos = [];
      partes.forEach(function (lista) { lista.forEach(function (p) { if (p && p.h && !vistos[p.h]) { vistos[p.h] = true; novos.push(p); } }); });
      if (!novos.length) return;
      PRODUCTS = PRODUCTS.concat(prepara(novos));
      renderGrids();
    });
  }

  /* ---------- trava de rolagem -----------------------------------------------
     Trava o HTML e o body: com html{overflow-x:clip}, travar so o body deixava
     a roda do mouse rolar a LP por tras do popup (armadilha da Peach Up). */
  var travas = 0;
  function travarRolagem() { travas++; D.documentElement.classList.add('gs-lock'); D.body.classList.add('gs-lock'); }
  function destravarRolagem() {
    travas = Math.max(0, travas - 1);
    if (!travas) { D.documentElement.classList.remove('gs-lock'); D.body.classList.remove('gs-lock'); }
  }

  /* ---------- ficha do produto ------------------------------------------------ */
  var pdpOvl, pdpBox, lastFocus = null;
  var PDP = { p: null, v: null };
  var INFO = {}; /* cache da parte pesada, por handle */

  function linhas(txt) { return String(txt || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean); }
  function bulletsHTML(txt) {
    var ls = linhas(txt);
    if (!ls.length) return '';
    return ls.length > 1 ? '<ul>' + ls.map(function (l) { return '<li>' + esc(l.replace(/^[-•]\s*/, '')) + '</li>'; }).join('') + '</ul>' : '<p>' + esc(ls[0]) + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim();
      return l ? '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>' : '';
    }).join('');
  }
  /* "Ingredientes explicados": blocos separados por ---, NOME na primeira
     linha; linha comecando com ⚠ e aviso e ganha destaque proprio. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var ls = linhas(bloco);
      if (!ls.length) return '';
      var nome = ls.shift();
      var aviso = ls.filter(function (x) { return /^⚠/.test(x); });
      var corpo = ls.filter(function (x) { return !/^⚠/.test(x); });
      return '<div class="gs-ing"><strong>' + esc(nome) + '</strong>' + esc(corpo.join(' ')) +
        (aviso.length ? '<span class="gs-warn">' + esc(aviso.join(' ')) + '</span>' : '') + '</div>';
    }).join('');
  }
  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="gs-acc"' + (open ? ' open' : '') + '><summary>' + esc(t(key)) + '</summary><div class="gs-acc__c">' + body + '</div></details>';
  }

  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="gs-pdp__qd" data-gs-pdp-qd><strong>' + esc(t('qd_t')) + '</strong><ul>' +
      passos.map(function (s) {
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(s.q >= 4 ? t('qd_4') : t('qd_' + s.q)) + '</span></li>';
      }).join('') + '</ul><small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small></div>';
  }
  function optHTML(p) {
    if (!p.multi) return '';
    var rotulo = p.opt && p.opt !== 'Title' ? p.opt : t('pdp_opt');
    return '<div class="gs-opt"><span class="gs-opt__l" id="gs-opt-l">' + esc(rotulo) + '</span>' +
      '<div class="gs-opt__list" role="group" aria-labelledby="gs-opt-l">' +
      p.v.map(function (v) {
        return '<button type="button" class="gs-opt__b" data-gs-var="' + v.id + '" aria-pressed="' + (PDP.v && PDP.v.id === v.id) + '"' +
          (v.av ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
      }).join('') + '</div></div>';
  }
  function pintarVariante() {
    var p = PDP.p, v = PDP.v;
    if (!p || !v) return;
    var preco = $('[data-gs-pdp-price]');
    if (preco) preco.innerHTML = v.cmpf ? '<s>' + esc(v.cmpf) + '</s>' + esc(v.prf) : esc(v.prf);
    var sku = $('[data-gs-pdp-sku]');
    if (sku) { sku.textContent = t('pdp_sku') + ': ' + (v.sku || '—'); sku.hidden = !v.sku; }
    $$('[data-gs-var]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.gsVar) === Number(v.id))); });
    $$('[data-gs-add],[data-gs-buy]', pdpBox).forEach(function (b) {
      var ehAdd = b.hasAttribute('data-gs-add');
      if (ehAdd) b.dataset.gsAdd = v.id; else b.dataset.gsBuy = v.id;
      b.disabled = !v.av;
      b.textContent = v.av ? (ehAdd ? t('add') : t('buy')) : t('soldout');
    });
    var qty = $('.gs-pdp__qty');
    if (qty) qty.hidden = !v.av;
    marcarDegrausPDP();
  }

  var PDP_QTD_MAX = 10;
  function qtdHTML() {
    return '<div class="gs-pdp__qty"><span class="gs-pdp__qty-l" id="gs-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="gs-step gs-step--lg" role="group" aria-labelledby="gs-pdp-qty-l">' +
      '<button type="button" data-gs-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
      '<span data-gs-pdp-qtd aria-live="polite">1</span>' +
      '<button type="button" data-gs-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button></span></div>';
  }
  function pdpQtd() {
    var el = $('[data-gs-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }
  function porQtdPDP(n) {
    var el = $('[data-gs-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-gs-pdp-step="-1"]'), mais = $('[data-gs-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
  }
  /* O Pumper conta o carrinho INTEIRO: acende o degrau do que o carrinho VAI
     ter depois de somar a quantidade escolhida aqui. */
  function marcarDegrausPDP() {
    var caixa = $('[data-gs-pdp-qd]');
    if (!caixa) return;
    var total = CART.count + pdpQtd();
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) atingido = s; });
    $$('li', caixa).forEach(function (li) { li.classList.toggle('is-on', !!atingido && Number(li.dataset.q) === atingido.q); });
  }
  /* O que abre o popup da garantia, de qualquer lugar: <label for>, nunca
     um link para outra guia (quem sai da LP perde o carrinho de vista). */
  function abreGarantia(rotulo) {
    return '<label class="gs-lnk" for="gs-guar-cbx" role="button" tabindex="0">' + esc(t(rotulo)) + '</label>';
  }
  function entregaHTML() {
    return '<div class="gs-pdp__del">' + SELO + '<div><b>' + esc(t('del_t')) + '</b><p>' + esc(t('del_pdp')) + '</p>' + abreGarantia('del_c') + '</div></div>';
  }

  /* A parte pesada da ficha: descricao completa + resumo por IA, pelo
     ?view=gold-spell-info. Se o template alternativo falhar, cai para o
     /products/<handle>.js da propria Shopify (so a descricao). */
  function carregaInfo(h) {
    if (INFO[h]) return Promise.resolve(INFO[h]);
    var base = (CFG.root || '') + '/products/' + encodeURIComponent(h);
    return fetch(base + '?view=gold-spell-info', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) { return JSON.parse(txt); })
      .catch(function () {
        return fetch(base + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { return { ai: {}, d: j.description || '' }; });
      })
      .then(function (info) { INFO[h] = info || { ai: {}, d: '' }; return INFO[h]; })
      .catch(function () { return { ai: {}, d: '' }; });
  }
  function pintaInfo(p, info) {
    var alvo = $('[data-gs-pdp-more]');
    if (!alvo || !PDP.p || PDP.p.h !== p.h) return;
    var ai = info.ai || {};
    var tag = $('[data-gs-pdp-tag]');
    if (tag) { tag.textContent = ai.tag || ''; tag.hidden = !ai.tag; }
    alvo.innerHTML =
      acc('pdp_purpose', bulletsHTML(ai.pur), true) +
      acc('pdp_high', bulletsHTML(ai.hig)) +
      acc('pdp_how', parasHTML(ai.how)) +
      acc('pdp_audience', parasHTML(ai.aud)) +
      acc('pdp_good', bulletsHTML(ai.gtk)) +
      acc('pdp_ing', ingHTML(ai.ing)) +
      acc('pdp_tog', parasHTML(ai.tog)) +
      /* HTML da propria loja (bloco .mkpbr-adeus, o padrao de descricao da
         MKPBR). Sem descricao, sem acordeao. */
      (info.d ? '<details class="gs-acc"' + (ai.pur ? '' : ' open') + '><summary>' + esc(t('pdp_desc')) + '</summary><div class="gs-acc__c gs-desc">' + info.d + '</div></details>' : '') +
      (info.note ? '<p class="gs-legal">' + esc(info.note) + '</p>' : '');
  }

  function openPDP(handle) {
    var p = porHandle(handle);
    if (!p || !pdpOvl) return;
    if (!pdpOvl.classList.contains('is-on')) lastFocus = D.activeElement;
    PDP.p = p;
    PDP.v = p.min; /* abre na variante disponivel mais barata, nunca numa esgotada */

    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-gs-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') + ' aria-label="' + (i + 1) + '/' + p.img.length + '">' +
        '<img src="' + esc(imgW(im.s, 120)) + '" alt="" loading="lazy"></button>';
    }).join('');
    var im0 = p.img[0] || {};
    pdpBox.innerHTML =
      '<button type="button" class="gs-x" data-gs-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="gs-pdp">' +
        '<div class="gs-pdp__gal">' +
          '<div class="gs-pdp__main">' + (im0.s ? '<img src="' + esc(imgW(im0.s, 900)) + '" alt="' + esc(im0.a || p.t) + '" width="900" height="900" data-gs-main>' : '') + '</div>' +
          (p.img.length > 1 ? '<div class="gs-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="gs-pdp__info">' +
          '<p class="gs-pdp__brand">Gold Spell · ' + esc(t('official')) + '</p>' +
          '<h2 id="gs-pdp-t">' + esc(p.t) + '</h2>' +
          starsHTML(p) +
          '<p class="gs-pdp__tag" data-gs-pdp-tag hidden></p>' +
          '<div class="gs-pdp__price" data-gs-pdp-price></div>' +
          optHTML(p) + qtdHTML() + qdHTML() +
          '<div class="gs-pdp__acts">' +
            '<button type="button" class="gs-btn gs-btn--ghost" data-gs-add=""></button>' +
            '<button type="button" class="gs-btn" data-gs-buy=""></button>' +
          '</div>' +
          entregaHTML() +
          '<div data-gs-pdp-more><div class="gs-skel" aria-hidden="true"><i></i><i></i><i></i></div></div>' +
          '<p class="gs-nota" style="margin:0" data-gs-pdp-sku></p>' +
        '</div>' +
      '</div>';

    if (!pdpOvl.classList.contains('is-on')) { pdpOvl.classList.add('is-on'); travarRolagem(); }
    pdpOvl.scrollTop = 0; pdpBox.scrollTop = 0;
    porQtdPDP(1);
    pintarVariante();
    var x = $('[data-gs-pdp-close]', pdpBox);
    if (x) x.focus();
    carregaInfo(p.h).then(function (info) { pintaInfo(p, info); });
  }
  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    PDP.p = null; PDP.v = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ---------------------------------------------------------- */
  var CART = { items: [], total: 0, count: Number((CFG.cart || {}).count) || 0, raw: null };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl;

  /* Recado de frete CALCULADO por window.MKPBR_SHIP (a mesma conta da barra
     da loja) e escrito dentro do carrinho. Ler o texto da barra pegaria o
     estado anterior: ela se redesenha depois do carrinho. */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) { shipEl.hidden = true; return; }
    var e;
    try { e = S.compute(CART.raw); } catch (err) { console.error('[gold-spell] frete', err); shipEl.hidden = true; return; }
    if (!e) { shipEl.hidden = true; return; }
    if (e.freeReached) shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      shipEl.innerHTML = '<b>' + esc(t('ship_more').replace('{v}', money(Math.round(e.faltaProximo * 100))).replace('{p}', money(Math.round(e.economiaProximo * 100)))) + '</b>';
    } else { shipEl.hidden = true; return; }
    shipEl.hidden = false;
  }
  function cartURL(path) { return (CFG.root || '') + path; }
  /* UM lugar so para absorver um carrinho do Shopify (lição da Peach Up). */
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }
  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); return c; })
      .catch(function (e) { console.error('[gold-spell] cart.js', e); });
  }
  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* a barra de frete da loja so aparece DEPOIS que existe carrinho */
    D.body.classList.toggle('gs-has-cart', CART.count > 0);
    renderCart();
    markStep();
  }
  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML = '<div class="gs-cart__empty"><strong>' + esc(t('c_empty')) + '</strong><span>' + esc(t('c_empty_d')) + '</span>' +
        '<button type="button" class="gs-btn gs-btn--ghost gs-btn--sm" data-gs-cart-close>' + esc(t('c_empty_cta')) + '</button></div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? imgW(it.image, 160) : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="gs-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="gs-line" data-key="' + esc(it.key) + '">' +
        '<div class="gs-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><span class="gs-line__t">' + esc(it.product_title || it.title) + '</span>' + vt +
          '<div class="gs-line__r"><span class="gs-step">' +
            '<button type="button" data-gs-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-gs-qty="1" aria-label="' + esc(t('c_more')) + '">+</button></span>' +
            '<span class="gs-line__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span></div>' +
          '<button type="button" class="gs-line__x" data-gs-rm>' + esc(t('c_rm')) + '</button>' +
        '</div></div>';
    }).join('');
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
  }
  function markStep() {
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (CART.count >= s.q) atingido = s; });
    $$('[data-gs-qd] .gs-qd__step').forEach(function (el) {
      el.classList.toggle('gs-qd__step--on', !!atingido && Number(el.dataset.q) === atingido.q);
    });
    marcarDegrausPDP();
    if (qdEl) {
      if (atingido) {
        qdEl.textContent = (atingido.q >= 4 ? t('qd_4') : t('qd_' + atingido.q)) + ' · ' + atingido.p + '% ' + t('off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else qdEl.hidden = true;
    }
    espelharFrete();
  }
  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    lastFocus = D.activeElement;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    espelharFrete();
    var c = $('[data-gs-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
    if (lastFocus && lastFocus.focus && !pdpOvl.classList.contains('is-on')) lastFocus.focus();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-gs-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  function addToCart(vid, abrir, btn, qtd) {
    if (!vid) return;
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var rotulo = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = t('added'); setTimeout(function () { btn.textContent = rotulo; }, 1400); }
        porQtdPDP(1);
        /* card e "adicionar" NAO abrem o carrinho; "comprar agora" abre */
        if (abrir) { closePDP(); openCart(); } else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[gold-spell] add', e);
        if (btn) { btn.disabled = false; btn.textContent = rotulo; }
        toast(t('err_add'));
      });
  }
  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(aplicarCarrinho)
      .catch(function (e) { console.error('[gold-spell] change', e); });
  }

  /* ---------- seletores de pais e idioma ---------------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.gs-pick__btn', wrap), menu = $('.gs-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharMenus();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var atual = $('[aria-current="true"]', menu);
      if (atual) atual.scrollIntoView({ block: 'nearest' });
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharMenus() {
    $$('.gs-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.gs-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  /* O pais prefere a janela do app Orbe (pais + moeda + idioma juntos); a
     lista nativa fica de reserva. mdApp_forceHideOrbe so trava o pop-up
     AUTOMATICO — a abertura sob demanda continua valendo. */
  function tentarOrbe() {
    try {
      var modal = D.getElementById('md-app-embed__footer-popup');
      if (typeof window.mdApp_openModal === 'function' && modal) { window.mdApp_openModal('md-app-embed__footer-popup'); return true; }
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }
  function abrirPais() {
    if (tentarOrbe()) return;
    var btn = $('[data-gs-country] .gs-pick__btn');
    if (btn) { window.scrollTo(0, 0); btn.click(); }
  }

  /* ---------- faixa de divergencia de mercado ------------------------------------
     Sinal: regiao do idioma do navegador; na falta, o fuso. SEM SINAL, NAO
     APARECE. So na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Asia/Qatar': 'QA', 'Asia/Kuwait': 'KW', 'Asia/Bahrain': 'BH', 'Asia/Muscat': 'OM',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone; if (tz && TZ2CC[tz]) return TZ2CC[tz]; } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-gs-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('gs-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = String(CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;
    var form = D.getElementById('gs-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */
    var nome = $('span', alvo);
    var nomeEl = $('[data-gs-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-gs-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-gs-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('gs-hint-off', '1'); } catch (e) { /* so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ---------- ligacao ------------------------------------------------------------- */
  function init() {
    $$('[data-gs-grid]').forEach(function (g) { g.setAttribute('aria-busy', 'true'); });

    cartEl = $('[data-gs-cart]'); veilEl = $('[data-gs-cart-veil]'); bodyEl = $('[data-gs-cart-body]');
    footEl = $('[data-gs-cart-foot]'); totalEl = $('[data-gs-cart-total]'); countEl = $('[data-gs-count]');
    qdEl = $('[data-gs-cart-qd]'); shipEl = $('[data-gs-cart-ship]');
    pdpOvl = $('[data-gs-pdp-ovl]'); pdpBox = $('[data-gs-pdp]');

    ligaBusca();
    ligaAbas();
    renderGrids();
    ligaVerTodos();
    ligaBarraFamilias();
    bindPicker($('[data-gs-lang]'));
    bindPicker($('[data-gs-country]'));
    D.body.classList.toggle('gs-has-cart', CART.count > 0);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { $$('.gs-rail').forEach(atualizaSetas); }, 150);
    });

    var btnPais = $('[data-gs-country] .gs-pick__btn');
    if (btnPais) btnPais.addEventListener('click', function (e) {
      if (tentarOrbe()) { e.stopImmediatePropagation(); fecharMenus(); }
    }, true);

    D.addEventListener('click', fecharMenus);

    /* Clique global. A ORDEM importa: controles internos da ficha, depois
       botoes de compra, depois o card (que tambem responde ao clique). */
    D.addEventListener('click', function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;

      var opt = alvo.closest('[data-gs-var]');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || !PDP.p) return;
        var nova = PDP.p.v.filter(function (v) { return Number(v.id) === Number(opt.dataset.gsVar); })[0];
        if (nova) { PDP.v = nova; pintarVariante(); }
        return;
      }
      var passo = alvo.closest('[data-gs-pdp-step]');
      if (passo) { e.preventDefault(); e.stopPropagation(); porQtdPDP(pdpQtd() + Number(passo.dataset.gsPdpStep)); return; }

      var add = alvo.closest('[data-gs-add]');
      if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.dataset.gsAdd, false, add, add.closest('.gs-pdp') ? pdpQtd() : 1); return; }
      var buy = alvo.closest('[data-gs-buy]');
      if (buy) { e.preventDefault(); e.stopPropagation(); addToCart(buy.dataset.gsBuy, true, buy, buy.closest('.gs-pdp') ? pdpQtd() : 1); return; }

      var abre = alvo.closest('[data-gs-open-handle]');
      if (abre) { e.preventDefault(); e.stopPropagation(); fecharBusca(); openPDP(abre.dataset.gsOpenHandle); return; }

      var termo = alvo.closest('[data-gs-term]');
      if (termo) { e.preventDefault(); abrirBusca(termo.dataset.gsTerm); return; }

      var card = alvo.closest('.gs-card');
      if (card && card.dataset.gsHandle) { openPDP(card.dataset.gsHandle); return; }

      if (alvo.closest('[data-gs-search-open]')) { abrirBusca(); return; }
      if (alvo.closest('[data-gs-search-close]') || alvo.closest('[data-gs-search-veil]')) { fecharBusca(); return; }
      if (alvo.closest('[data-gs-nostock-country]')) { abrirPais(); return; }
      if (alvo.closest('[data-gs-cart-open]')) { openCart(); return; }
      if (alvo.closest('[data-gs-cart-close]') || alvo.closest('[data-gs-cart-veil]')) { closeCart(); return; }
      if (alvo.closest('[data-gs-pdp-close]') || alvo === pdpOvl) { closePDP(); return; }

      var th = alvo.closest('[data-gs-th]');
      if (th) {
        var i = Number(th.dataset.gsTh), main = $('[data-gs-main]');
        if (PDP.p && main && PDP.p.img[i]) {
          main.src = imgW(PDP.p.img[i].s, 900);
          main.alt = PDP.p.img[i].a || PDP.p.t;
          $$('[data-gs-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }
      var qty = alvo.closest('[data-gs-qty]');
      if (qty) {
        var linhaEl = qty.closest('.gs-line');
        var atual = CART.items.filter(function (it) { return it.key === linhaEl.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.gsQty));
        return;
      }
      var rm = alvo.closest('[data-gs-rm]');
      if (rm) { var l2 = rm.closest('.gs-line'); if (l2) changeQty(l2.dataset.key, 0); }
    });

    /* Teclado. O popup da garantia e um checkbox: o Escape fecha SO ele quando
       estiver aberto (sem isso fechava a ficha e o carrinho e deixava a
       garantia por cima). <label role="button"> nao responde a Enter/Espaco
       sozinho — o navegador so liga label e controle no clique. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var cbx = D.getElementById('gs-guar-cbx');
        if (cbx && cbx.checked) { cbx.checked = false; return; }
        closePDP(); closeCart(); fecharBusca(); fecharMenus(); return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target;
      if (!el || !el.closest) return;
      var lbl = el.closest('label[for="gs-guar-cbx"]');
      if (lbl) { e.preventDefault(); var c = D.getElementById('gs-guar-cbx'); if (c) c.checked = !c.checked; return; }
      var card = el.closest('.gs-card');
      if (card && card === el && card.dataset.gsHandle) { e.preventDefault(); openPDP(card.dataset.gsHandle); }
    });

    /* O resto do catalogo e o carrinho descem EM PARALELO, depois da primeira
       pintura (a versao 1 fazia um depois do outro). */
    carregarResto();
    fetchCart().then(marketHint);
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
